export default {
  independentMarketing: {
    common: {
      requestFailed: 'Gränssnittsbegäran misslyckades',
      hintSelect: 'Välj',
      hintInput: 'Stiga på',
      submit: 'Skicka in',
      cancel: 'Annullera',
      confirm: 'OK',
    },
    agreement: {
      title: 'Autel oberoende återförsäljarregistreringsavtal',
      nextBtn: 'Nästa',
      getAgreementFailed: 'Det gick inte att hämta avtalsinnehåll.',
    },
    successPage: {
      title:
        'Din ansökningsinformation har skickats in och granskningsresultaten kommer att skickas till din e-post $1 inom 15 arbetsdagar. Kontrollera din inkorg för mer information.',
      subTitle: 'Återgå till startsidan efter $1 sekund(er).',
    },
    applyTitle:
      'Du ansöker om att bli en oberoende Autel-återförsäljare. Vänligen fyll i följande information korrekt:',
    companyName: 'Företagsnamn',
    companyTax: 'VAT ID',
    userCountry: 'Land',
    legalPerson: 'Juridiskt biträde',
    contactEmail: 'Kontakt e-post',
    contactEmailTips:
      'Den här e-postadressen kommer att vara din kontaktperson, e-postmeddelandet med granskningsresultatet. När recensionen har godkänts kommer den också att användas som inloggningskontonamn för det oberoende återförsäljarhanteringssystemet.',
    corporateIdentity: 'Jurist-ID',
    uploadTips: 'JPG, JPEG, PNG, PDF (inte större än 20 MB)',
    businessLicense: 'Företagslicens',
    emailErrorTips: 'Ange en giltig e-postadress.',
    uploadPic: 'Ladda upp bilder',
    picMaxLimit: 'Den maximala bildstorleken är 20 MB. Välj igen.',
  },
};
